import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M12.517 18.16q-1.137 0-2.034-.427a3.6 3.6 0 0 1-1.426-1.182 3.13 3.13 0 0 1-.557-1.716h2.046q.056.716.619 1.17.563.45 1.352.45.62 0 1.102-.284.483-.285.762-.79.278-.506.272-1.154.006-.66-.278-1.17a2.1 2.1 0 0 0-.778-.801 2.17 2.17 0 0 0-1.137-.296 2.7 2.7 0 0 0-1.028.193 2.1 2.1 0 0 0-.801.523l-1.904-.312.608-6h6.75v1.761H11.08l-.335 3.085h.069q.323-.381.914-.63.591-.256 1.296-.256 1.056 0 1.886.5.83.495 1.307 1.364t.477 1.988q0 1.155-.534 2.057a3.8 3.8 0 0 1-1.471 1.415q-.939.51-2.171.511Z"
    }, null, -1)
  ])))
}
export default { render: render }